export default theme => ({
  freeTag: {
    backgroundColor: theme.success[300],
    marginRight: '8px !important',
    padding: '4px 6px !important',
    textTransform: 'uppercase',
    borderRadius: 4
  }
})
